import { UserCircle } from '@phosphor-icons/react'
import React from 'react'
import { Org } from 'store/modules/orgs'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'

type OrgPersonalSkillsLinkProps = {
  className?: string
  org: Org
}

export const OrgPersonalSkillsLink: React.FC<OrgPersonalSkillsLinkProps> = (
  props
) => {
  const { className, org } = props
  const title = 'Personal Skills (All employees)'

  const path = org.personalSkillsPath

  return (
    <SideMenu.LinkItem
      active={useIsActive(path)}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
      className={className}
      href={path}
      icon={UserCircle}
    >
      {title}
    </SideMenu.LinkItem>
  )
}
